import React, { useState, useEffect } from 'react';
import {
  Handshake,
  ChevronRight,
  ExternalLink,
  MonitorPlay,
  Users,
  Briefcase,
  UserCheck,
  Building2,
  GraduationCap,
  Mail,
  ArrowRight,
  CheckCircle2
} from 'lucide-react';
import Layout from '../component/layout/Layout';
import ConsultationModal from '../component/ConsultationModal';

import brspc from "../assets/images/brspc.png";
import bgcbcp from "../assets/images/government-vocational-training-institute-logo-15-05-2017 (1).jpg";
import iti from "../assets/images/partnerCourses/iti.png";
import bsm from "../assets/images/partnerCourses/logo-202001100553154953.png";
import heroBg from "../assets/images/HomeBackground.png";

export default function PartnersPage() {
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 1024 : true);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 640 : false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
      setIsMobile(window.innerWidth < 640);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const partners = [
    { name: 'B.S.M College of Technology and Management', logo: bsm, category: 'Technical Training', logoScale: 1 },
    { name: 'Babu Goverdhan Chand Bachcha Chand Private ITI', logo: bgcbcp, category: 'Technical Training', logoScale: 1 },
    { name: 'Government ITI Bhor', logo: iti, category: 'Technical Training', logoScale: 1.4 },
    { name: 'Lalita Devi Dharam Dev Singh Private ITC', logo: iti, category: 'Technical Training', logoScale: 1.4 },
    { name: 'Sarda Devi Ram Lal Tripathi Private ITI', logo: iti, category: 'Technical Training', logoScale: 1.4 },
    { name: 'Government ITI Gohana', logo: iti, category: 'Technical Training', logoScale: 1.4 },
    { name: 'Government ITI,Maihar', logo: iti, category: 'Technical Training', logoScale: 1.4 },
    { name: 'Lalita Devi Dharam Dev Singh Private ITC - Deoria', logo: iti, category: 'Technical Training', logoScale: 1.4 },
    { name: 'Baba Ramdal Surajdev Polytechnic College,Patna Rasra, Ballia', logo: brspc, category: 'Technical Training', logoScale: 1 }
  ];

  const partnerBenefits = [
    {
      title: 'Digital Learning Platform',
      description: 'Deliver courses through a structured LMS designed for scalable learning.',
      icon: MonitorPlay
    },
    {
      title: 'Reach More Learners',
      description: 'Connect with professionals and organizations seeking industry-focused training.',
      icon: Users
    },
    {
      title: 'Industry-Aligned Courses',
      description: 'Programs designed to support practical skill development and workforce readiness.',
      icon: Briefcase
    }
  ];

  const partnerTypes = [
    { title: 'Subject Matter Experts', icon: UserCheck },
    { title: 'Training institutes and academies', icon: Building2 },
    { title: 'Industry professionals', icon: Handshake },
    { title: 'Corporate training providers', icon: GraduationCap }
  ];

  const handlePartnerClick = () => {
    window.location.href = "https://admin.skillserve.in/";
  };

  const pageWrapStyle = {
    width: '100%',
    minHeight: '100vh',
    background: '#ffffff',
    fontFamily: "'Inter', 'Roboto', sans-serif"
  };

  const heroStyle = {
    width: '100%',
    position: 'relative',
    minHeight: isDesktop ? '60vh' : '50vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${heroBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    padding: isMobile ? '80px 20px 96px' : '100px 20px 120px',
    overflow: 'hidden'
  };

  const heroOverlayStyle = {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(135deg, rgba(11, 49, 97, 0.78) 0%, rgba(6, 30, 61, 0.9) 100%)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    zIndex: 1
  };

  const heroContentStyle = {
    position: 'relative',
    zIndex: 2,
    maxWidth: '880px',
    textAlign: 'center',
    color: '#ffffff'
  };

  const WaveDivider = () => (
    <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', overflow: 'hidden', lineHeight: 0, zIndex: 3 }}>
      <svg viewBox="0 0 1440 320" preserveAspectRatio="none" style={{ position: 'relative', display: 'block', width: 'calc(100% + 1.3px)', height: isMobile ? '60px' : '100px' }}>
        <path fill="#ffffff" fillOpacity="1" d="M0,192L48,197.3C96,203,192,213,288,197.3C384,181,480,139,576,138.7C672,139,768,181,864,208C960,235,1056,245,1152,234.7C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
      </svg>
    </div>
  );

  const sectionContentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: isDesktop ? '80px 24px' : '60px 20px'
  };

  const titleStyle = {
    fontFamily: "'Roboto Slab', serif",
    fontSize: isDesktop ? '2.5rem' : '2rem',
    fontWeight: 800,
    color: '#0b3161',
    marginBottom: '24px',
    lineHeight: 1.2
  };

  const descStyle = {
    fontSize: '1.08rem',
    lineHeight: 1.8,
    color: '#475569',
    marginBottom: '20px'
  };

  const heroButtonPrimaryStyle = {
    background: 'linear-gradient(90deg, #fdd649, #f7c42d)',
    color: '#081426',
    border: 'none',
    padding: '16px 34px',
    borderRadius: '12px',
    fontSize: '1.05rem',
    fontWeight: 800,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 8px 24px rgba(253, 214, 73, 0.35)',
    transition: 'transform 0.2s ease'
  };

  const heroButtonSecondaryStyle = {
    background: 'rgba(255,255,255,0.08)',
    color: '#ffffff',
    border: '2px solid rgba(255,255,255,0.35)',
    padding: '14px 34px',
    borderRadius: '12px',
    fontSize: '1.05rem',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'background 0.2s ease, transform 0.2s ease',
    backdropFilter: 'blur(4px)'
  };

  const partnersGridStyle = {
    display: 'grid',
    gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : isMobile ? '1fr' : 'repeat(2, 1fr)',
    gap: '32px',
    maxWidth: '1100px',
    margin: '0 auto'
  };

  const partnerCardStyle = (isHovered) => ({
    background: '#ffffff',
    borderRadius: '16px',
    padding: isMobile ? '28px 20px' : '36px 28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: isMobile ? '200px' : '260px',
    border: '2px solid #e8f0fb',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: isHovered ? 'translateY(-6px) scale(1.02)' : 'translateY(0) scale(1)',
    boxShadow: isHovered ? '0 20px 40px rgba(11,49,97,0.12)' : '0 4px 16px rgba(11,49,97,0.04)',
    position: 'relative',
    overflow: 'hidden'
  });

  const logoWrapperStyle = {
    width: '100%',
    height: isMobile ? '110px' : '150px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    position: 'relative'
  };

  const logoImgStyle = (isHovered, scale = 1) => ({
    maxWidth: `${90 * scale}%`,
    maxHeight: `${100 * scale}%`,
    objectFit: 'contain',
    filter: 'none',
    opacity: isHovered ? 1 : 0.95,
    transition: 'all 0.3s ease',
    transform: isHovered ? `scale(${1.05 * scale})` : `scale(${scale})`
  });

  const partnerNameStyle = {
    fontSize: '1.05rem',
    fontWeight: 700,
    color: '#0b3161',
    textAlign: 'center',
    marginBottom: '10px',
    lineHeight: 1.3
  };

  const loginIconStyle = (isHovered) => ({
    position: 'absolute',
    top: '16px',
    right: '16px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    background: isHovered ? 'linear-gradient(135deg, #fdd649 0%, #f7c42d 100%)' : 'rgba(11,49,97,0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: isHovered ? 1 : 0.8,
    transition: 'all 0.3s ease',
    color: isHovered ? '#081426' : '#0b3161',
    transform: isHovered ? 'rotate(45deg)' : 'rotate(0)'
  });

  const ctaSectionStyle = {
    textAlign: 'center',
    padding: isDesktop ? '48px 24px' : isMobile ? '36px 16px' : '44px 20px',
    background: 'linear-gradient(135deg, #0b3161 0%, #1a4a82 100%)',
    borderRadius: '20px',
    color: '#ffffff',
    marginTop: '48px'
  };

  const ctaTitleStyle = {
    fontFamily: "'Roboto Slab', serif",
    fontSize: isDesktop ? '2rem' : isMobile ? '1.5rem' : '1.75rem',
    fontWeight: 700,
    margin: '0 0 16px 0',
    lineHeight: 1.2
  };

  const ctaDescStyle = {
    fontSize: '1.05rem',
    lineHeight: 1.6,
    color: 'rgba(255,255,255,0.95)',
    maxWidth: '700px',
    margin: '0 auto 28px'
  };

  const secondaryButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    background: 'transparent',
    color: '#ffffff',
    padding: '12px 28px',
    borderRadius: '10px',
    fontSize: isMobile ? '0.95rem' : '1rem',
    fontWeight: 600,
    border: '2px solid rgba(255,255,255,0.3)',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  };

  return (
    <Layout>
      <div style={pageWrapStyle}>
        <section style={heroStyle}>
          <div style={heroOverlayStyle} />
          <div style={heroContentStyle}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: 'rgba(253, 214, 73, 0.15)',
              color: '#fdd649',
              padding: '8px 20px',
              borderRadius: '999px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              marginBottom: '24px',
              border: '1px solid rgba(253, 214, 73, 0.3)'
            }}>
              <Handshake size={16} />
              Partner With SkillServe
            </div>

            <h1 style={{ ...titleStyle, color: '#ffffff', fontSize: isDesktop ? '3.4rem' : '2.4rem', textShadow: '0 4px 20px rgba(0,0,0,0.35)', marginBottom: '24px' }}>
              Deliver High-Impact Learning Programs Through SkillServe
            </h1>

            <p style={{ ...descStyle, color: '#e2e8f0', fontSize: '1.18rem', maxWidth: '820px', margin: '0 auto 18px' }}>
              SkillServe invites Subject Matter Experts, training organizations, and industry professionals to collaborate and deliver high-quality learning programs through our digital platform.
            </p>
            <p style={{ ...descStyle, color: '#dbe7f5', fontSize: '1.08rem', maxWidth: '820px', margin: '0 auto 40px' }}>
              Through the SkillServe Learning Management System (LMS), partners can host courses, reach a wider learner base, and contribute to industry-relevant skill development.
            </p>

            <div style={{ display: 'flex', gap: '18px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => setIsModalOpen(true)}
                style={heroButtonPrimaryStyle}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
              >
                Apply as Partner <ArrowRight size={20} />
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                style={heroButtonSecondaryStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.16)';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                  e.currentTarget.style.transform = 'none';
                }}
              >
                Contact Us <Mail size={20} />
              </button>
            </div>
          </div>
          <WaveDivider />
        </section>

        <section style={{ ...sectionContentStyle, paddingTop: isDesktop ? '100px' : '60px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: isDesktop ? '1.1fr 0.9fr' : '1fr', gap: isDesktop ? '56px' : '36px', alignItems: 'center' }}>
            <div>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: 'rgba(253, 214, 73, 0.1)',
                color: '#0b3161',
                padding: '6px 16px',
                borderRadius: '999px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: '20px',
                border: '1px solid rgba(253, 214, 73, 0.4)'
              }}>
                <CheckCircle2 size={14} /> Introduction
              </div>
              <h2 style={{ ...titleStyle, fontSize: isDesktop ? '2.4rem' : '1.9rem' }}>
                Build scalable, industry-relevant learning experiences with us.
              </h2>
              <p style={{ ...descStyle, fontSize: '1.1rem', color: '#334155', fontWeight: 500 }}>
                SkillServe works with experts, institutes, and training providers who want to deliver practical programs that create real learner impact.
              </p>
              <p style={descStyle}>
                Our platform supports structured digital learning, helping partners publish courses, engage wider audiences, and contribute to workforce readiness with accessible, high-quality content.
              </p>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, #0b3161 0%, #1a4a82 100%)',
              borderRadius: '24px',
              padding: isDesktop ? '40px' : '28px',
              color: '#ffffff',
              boxShadow: '0 20px 40px rgba(11,49,97,0.18)'
            }}>
              <h3 style={{ fontSize: '1.25rem', fontWeight: 700, margin: '0 0 24px', color: '#fdd649' }}>
                Why Partner With SkillServe
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {partnerBenefits.map((item, index) => {
                  const Icon = item.icon;
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        gap: '14px',
                        alignItems: 'flex-start',
                        background: 'rgba(255,255,255,0.06)',
                        padding: '18px',
                        borderRadius: '16px',
                        border: '1px solid rgba(255,255,255,0.1)'
                      }}
                    >
                      <div style={{
                        width: '46px',
                        height: '46px',
                        borderRadius: '14px',
                        background: 'rgba(253, 214, 73, 0.12)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                      }}>
                        <Icon size={22} color="#fdd649" />
                      </div>
                      <div>
                        <div style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '6px' }}>{item.title}</div>
                        <div style={{ fontSize: '0.98rem', lineHeight: 1.6, color: '#dbe7f5' }}>{item.description}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: '#f8fafc', padding: isDesktop ? '30px 0 90px' : '24px 0 70px' }}>
          <div style={sectionContentStyle}>
            <div style={{ textAlign: 'center', marginBottom: '42px' }}>
              <div style={{ display: 'inline-flex', justifyContent: 'center', marginBottom: '16px', background: '#e2e8f0', padding: '12px', borderRadius: '16px' }}>
                <Users size={30} color="#0b3161" />
              </div>
              <h2 style={{ ...titleStyle, marginBottom: '16px' }}>Who Can Partner</h2>
              <p style={{ ...descStyle, maxWidth: '760px', margin: '0 auto', fontSize: '1.1rem' }}>
                SkillServe welcomes collaboration with professionals and organizations that want to deliver meaningful, industry-focused training experiences.
              </p>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: isDesktop ? 'repeat(4, 1fr)' : isMobile ? '1fr' : 'repeat(2, 1fr)',
              gap: '22px'
            }}>
              {partnerTypes.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div
                    key={index}
                    style={{
                      background: '#ffffff',
                      borderRadius: '20px',
                      padding: isMobile ? '28px 22px' : '34px 24px',
                      textAlign: 'center',
                      border: '1px solid #dbe6f2',
                      boxShadow: '0 10px 24px rgba(11,49,97,0.06)'
                    }}
                  >
                    <div style={{
                      width: '70px',
                      height: '70px',
                      margin: '0 auto 18px',
                      borderRadius: '50%',
                      background: 'rgba(253, 214, 73, 0.16)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Icon size={30} color="#0b3161" />
                    </div>
                    <h3 style={{ fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.5, color: '#081426', margin: 0 }}>
                      {item.title}
                    </h3>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section style={{ ...sectionContentStyle, paddingTop: isDesktop ? '20px' : '10px', paddingBottom: isDesktop ? '80px' : '60px' }}>
          <div style={{
            background: 'linear-gradient(135deg, #0b3161 0%, #1a4a82 100%)',
            borderRadius: '28px',
            padding: isDesktop ? '56px' : '36px 24px',
            color: '#ffffff',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              position: 'absolute',
              inset: 0,
              backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.14) 2px, transparent 0)',
              backgroundSize: '28px 28px',
              opacity: 0.4
            }} />
            <div style={{ position: 'relative', zIndex: 1, maxWidth: '820px', margin: '0 auto' }}>
              <h2 style={{ ...titleStyle, color: '#ffffff', fontSize: isDesktop ? '2.8rem' : '2rem', marginBottom: '18px' }}>
                Become a SkillServe Training Partner
              </h2>
              <p style={{ fontSize: '1.12rem', lineHeight: 1.7, color: '#dbe7f5', margin: '0 auto 34px' }}>
                Share your expertise, deliver impactful training programs, and reach a wider learning community through the SkillServe platform.
              </p>
              <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button
                  onClick={() => setIsModalOpen(true)}
                  style={heroButtonPrimaryStyle}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
                >
                  Apply as Partner <ArrowRight size={20} />
                </button>
                <button
                  onClick={() => setIsModalOpen(true)}
                  style={heroButtonSecondaryStyle}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.16)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                    e.currentTarget.style.transform = 'none';
                  }}
                >
                  Contact Us <Mail size={20} />
                </button>
              </div>
            </div>
          </div>
        </section>

        <section style={{ width: '100%', padding: isDesktop ? '30px 24px 80px' : '20px 16px 56px', background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '48px' }}>
              <h2 style={{ ...titleStyle, marginBottom: '16px' }}>Our Academic Network</h2>
              <p style={{ ...descStyle, maxWidth: '760px', margin: '0 auto' }}>
                Partnering with prestigious institutions to bridge the gap between education and employment through industry-aligned training programs.
              </p>
            </div>

            <div style={partnersGridStyle}>
              {partners.map((partner, index) => {
                const isHovered = hoveredCard === index;

                return (
                  <div
                    key={index}
                    style={partnerCardStyle(isHovered)}
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={handlePartnerClick}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handlePartnerClick(); }}
                    aria-label={`Open ${partner.name}`}
                  >
                    <div style={loginIconStyle(isHovered)}>
                      <ExternalLink size={16} />
                    </div>

                    <div style={logoWrapperStyle}>
                      <img
                        src={partner.logo}
                        alt={`${partner.name} logo`}
                        style={logoImgStyle(isHovered, partner.logoScale || 1)}
                        onError={(e) => {
                          e.target.src = `https://via.placeholder.com/300x120/0b3161/ffffff?text=${encodeURIComponent(partner.name.substring(0, 15))}`;
                        }}
                      />
                    </div>

                    <div style={partnerNameStyle}>{partner.name}</div>
                  </div>
                );
              })}
            </div>

            <div style={ctaSectionStyle}>
              <h3 style={ctaTitleStyle}>Collaborate With SkillServe as an Academic Partner</h3>
              <p style={ctaDescStyle}>
                Work with us to integrate industry-oriented learning solutions that enhance employability and workforce readiness.
              </p>
              <button
                style={secondaryButtonStyle}
                onClick={() => setIsModalOpen(true)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                }}
              >
                Become a Partner
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </section>
      </div>
      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        defaultQueryOption="Looking for Acedemic and training parternershipt"
      />
    </Layout>
  );
}

